/*
Sohel 09/19/2022 3075154998 Data Manager Matching Logic ->Integrated API,Added System Notes and Suggested Changes
Sohel 11/02/2022 2699761741 Added Event Tactic group
Sohel 11/16/2022 2700912712 Added BRE Filter
Sai maheshwar 01/06/2023 2701334326 added function lookup
Ashraf 01/11/2022 2700799562 added client audit list redux slice
// Sai Maheshwar 01/12/2022 2701306337 ,2701326866  add intermediate repo field API integration
Akhila 02/28/2023 2699761741 Added loader and download toast message in preview FIle
gireesh 10/20/2023 5314470832 Added Agent / Advocate details Integrated API
Sohel 10/27/2023 5314470832 Added Eligibilty scrub pronto screen 
*/
import {connectRouter} from 'connected-react-router';
import Common from './Common';
import Auth from './Auth';
import Spouse from './Spouse';
import SpecNotes from './SpecNotes';
import PatientInterAction from './PatientInterAction';
import CustomerAttorney from './CustomerAttorney';
import BankruptcyHistory from './BankruptcyHistory';
import AccountLegalActions from './AccountLegalActions';
import ClientInfo from './coreWindows/clientInformation';
import MultipleAccountInfo from './coreWindows/MultipleAccountInformation';
import AccountGuarantor from './AccountGuarantor';
import AccountNotes from './AccountNotes';
import StatuteLimitation from './StatuteLimitation';
import CustmAtrny from './coreWindows/CustomerAttorney';
import AccountSummary from './AccountSummary';
import AccountStatus from './AccountStatus';
import CustomerDemographics from './CustomerDemographics';
import Poe from './Poe';
import CreditReport from './CreditReport';
import LegalInformation from './coreWindows/LegalInformation';
import Search from './search';
import DocumentManagement from './DocumentManagement';
import Note from './coreWindows/Note';
import UserDefinedWindow from './UserDefinedWindow';
import TextHistory from './TextHistory';
import AdvanceSearch from './AdvanceSearch';
import AccountTie from './coreWindows/AccountTie';
import Disposition from './DispositionTimeline';
import ClientGeneral from './client-maintainance/ClientGeneral';
import ParentClientName from './client-maintainance/ParentClient/ParentClientName';
import CollectionDepartments from './ClientMaintenance/Collection/CollectionDepartments';

import CollectScreen from './ClientMaintenance/Collection/CollectScreen';
import ClientContact from './client-maintainance/ClientContact';
import NewBusiness from './ClientMaintenance/NewBusiness';

import DebtorCashGeneral from './ClientMaintenance/DebtorCash/DebtorCashGeneral';
import ApplySequence from './ClientMaintenance/DebtorCash/ApplySequence';
import CreditBalanceControl from './ClientMaintenance/DebtorCash/CreditBalanceControl';
import StatementStandard from './ClientMaintenance/Statement/Standard';
import DisplayUserDefinedTables from './ClientMaintenance/DisplayUserDefinedTables/index';
import RefreshToken from './RefreshToken';
import CreditReporting from './ClientMaintenance/CreditBureaus/CreditReporting';
import Billing from './ClientMaintenance/Billing/Billing';
import Interest from './ClientMaintenance/Interest/Interest';
import SeparateStatementsSettings from './ClientMaintenance/StatementSettings';
import TyingRestrictions from './ClientMaintenance/Collection/TyingRestriction';
import AddOnCharges from './ClientMaintenance/AddOnCharges';
import BalanceNames from './ClientMaintenance/DebtorCash/BalanceNames';
import ClientNotes from './ClientMaintenance/AddaNote';
import InsuranceClaims from './ClientMaintenance/InsuranceClaims';
import EoPassRequirements from './ClientMaintenance/EoPassRequirements/EoPassRequirements';
import Salesman from './ClientMaintenance/Salesman';
import SeparateStatement from './ClientMaintenance/Statement/separateStatement';
import DebtorBatch from './DebtorCash/DebtorBatch';
import DebtorReversalEntry from './DebtorCash/DebtorReversalEntry';
import CashBalanceReport from './DebtorCash/DebtorCashBalanceReport';
import ReapplyCorrection from './DebtorCash/ReapplyCorrection';
import AddNewPayment from './DebtorCash/AddNewPayment';
import AddPayment from './DebtorCash/AddPayment';
import FavouriteWindows from './FavouriteWindows';
import Reports from './ClientMaintenance/Reports';
import CorrespondingClient from './ClientMaintenance/CorrespondingClient';
import ParentClientContactInfo from './ParentClientContactInfo';
import UdwWindows from './UDW/UdwWindows';
import AddRuleGroup from './BRE/AddRuleGroup';
import GlobalField from './GlobalField/GlobalField';
import LogIn from './Login';
import AddLetterData from './LetterMaintainance/AddLetterData';
import CommmunicaionLetter from './LetterMaintainance/LetterCommunication';
import LetterSummary from './LetterMaintainance/LetterSummary';
import PostSearch from './LetterMaintainance/MaintainLetters';
import GlobalFieldGroup from './GlobalField/GlobalFieldGroup';
import AddReportMaster from './BRE/AddReportMaster';
import AddRecordFormat from './BRE/AddRecordFormat';
import AddEventTactic from './EventTactics/EventTactics';
import AddMediaType from './EnableFramework/AddMediaType';
import Filter from './EnableFramework/Filter';
import FilterGroup from './EnableFramework/FilterGroup';
import AddEnableFileFormat from './EnableFramework/AddEnableFileFormat';
import AddNightJob from './NightJobs/AddNightJob';
import AddFieldList from './GlobalField/AddFieldList';
import UDWlookup from './UDW/UDWlookup';
import WorkQueue from './WorkQueue';
import Role from './role';
import NotepadTable from './NotepadTable';
import Columns from './DashboardSettings';
import AddRole from './RoleManagement/AddRole';
import AddUser from './UserManagement/AddUser';
import CommunicationTimeLine from './CommunicationTimeLine';
import ViewRateTable from './ViewRateTable';
import EditRateTable from './EditRateCard';
import ForgotPassword from './forgotPassword';
import NbMaintenance from './NbMaintenance';
import SystemNote from './BRE/SystemNotes';
import RecordAddNotes from './RecordFormat/addANote';
import AddNoteEvent from './EventTactics/AddNote';
import ClientData from './clientSearch';
import UnlockUser from './UserManagement/UnlockUser';
import DashboardClient from './ClientDashboard';
import DMMatchingLogic from './DMMatchingLogic';
import LetterBatches from './LetterBatches';
import LetterHistory from './LetterHistory';
import LetterGroup from './LetterGroup';
import LetterGroupUsage from './letterGroupUsage';
import LetterControlList from './LetterMaintainance/LetterControlList';
import ClientRateHistory from './ClientRateHistory';
import printUsage from './printUsage/index';
import addPatient from './AddPatient';
import addTriggerGroup from './TriggerGroup';
import DataManager from './EnableFramework/DataManager';
import DmRecords from './EnableFramework/DmRecords';
import DataManagerFilter from './DataManagerFilter';
import DMRecord from './DMRecord';
import DMFilterGroup from './DMFilterGroup';
import ReportMaster from './ReportMaster';
import EventTriggerGroup from './EventTriggerGroup';
import FilterRuleGroup from './BRE/FilterRuleGroup';
import AccountUpdateGroup from './AccountUpdateGroup';
import DataRepository from './GlobalField/DataRepository';
import UnsavedChangesAlertReducer from './UnsavedChangesAlertReducer';
import DataManagerRecord from './DataManagerRecord';
import DataManagerGroup from './DataManager';
import DataManagerRecordGroup from './DataManagerRecordGroup';
import lookupReducer from './lookupReducer';
import AuditFieldList from './GlobalField/ClientAuditList';
import IntermediateRepository from './IntermediateRepository';
import AccountBatch from './accountBatch';
import Organization from './clientMangement/Organizaation';
import AddPrviewFile from './PreviewFile/index';
import PreviewFileData from './PreviewFileData';
import TranslationTableData from './TranslationTable';
import AddLookupMaintenance from './LookupMaintenance/AddLookup';
import NewLetterMaintenance from './LetterMaintainance/NewLetterMaintenance/index';
import CommonActions from './CommonActions/commonActions';
import EdiExport from './EDI/index';
import EdiFilterExport from './EDI/index2';
import AddWorkQueue from '../reducers/WorkQueueSetup/index';
import WorkQueueList from './WorkQueueList';
import BillingIndicator from './BillingIndicator';
import AgentInformation from './AgentInformation';
import MyCoverageCare from './MyCoverageCare';
import ModifiedWindows from "./ModifiedWindows";
import saveAllWindowsSlice from "./SaveAllWindows";
import eligibleScrub from './EligibiltyScrubs/index';

export default (history) => ({
  router: connectRouter(history),
  common: Common,
  auth: Auth,
  spouse: Spouse,
  specNotes: SpecNotes,
  patientInterAction: PatientInterAction,
  customerAttorney: CustomerAttorney,
  bankruptcyHistory: BankruptcyHistory,
  accountLegalActions: AccountLegalActions,
  clientInfo: ClientInfo,
  accountGuarantor: AccountGuarantor,
  accountNotes: AccountNotes,
  statuteLimitation: StatuteLimitation,
  custmAtrny: CustmAtrny,
  accountSummary: AccountSummary,
  accountStatus: AccountStatus,
  customerDemographics: CustomerDemographics,
  poe: Poe,
  multipleAccountInfo: MultipleAccountInfo,
  legalInformation: LegalInformation,
  documentManagement: DocumentManagement,
  note: Note,
  userDefinedWindow: UserDefinedWindow,
  creditReport: CreditReport,
  search: Search,
  textHistory: TextHistory,
  advanceSearch: AdvanceSearch,
  accountTie: AccountTie,
  disposition: Disposition,
  clientGeneral: ClientGeneral,
  parentClientName: ParentClientName,
  collectionDepartments: CollectionDepartments,
  debtorCashGeneral: DebtorCashGeneral,
  applySequence: ApplySequence,
  statementStandard: StatementStandard,
  displayUserDefinedTables: DisplayUserDefinedTables,
  creditReporting: CreditReporting,
  billing: Billing,
  collectScreen: CollectScreen,
  clientContact: ClientContact,
  newBusiness: NewBusiness,
  interest: Interest,
  separateStatementsSettings: SeparateStatementsSettings,
  tyingRestrictions: TyingRestrictions,
  addOnCharges: AddOnCharges,
  balanceNames: BalanceNames,
  creditBalanceControl: CreditBalanceControl,
  clientNotes: ClientNotes,
  insuranceClaims: InsuranceClaims,
  eoPassRequirements: EoPassRequirements,
  salesman: Salesman,
  separateStatement: SeparateStatement,
  debtorBatch: DebtorBatch,
  debtorReversalEntry: DebtorReversalEntry,
  cashBalanceReport: CashBalanceReport,
  reApplyCorrection: ReapplyCorrection,
  addNewPayment: AddNewPayment,
  addPayment: AddPayment,
  favouriteWindows: FavouriteWindows,
  reports: Reports,
  correspondingClient: CorrespondingClient,
  parentClientContactInfo: ParentClientContactInfo,
  udwWindows: UdwWindows,
  addRuleGroup: AddRuleGroup,
  globalField: GlobalField,
  addLetterData: AddLetterData,
  commmunicaionLetter: CommmunicaionLetter,
  addEventTactic: AddEventTactic,
  letterSummary: LetterSummary,
  addMediaType: AddMediaType,
  filter: Filter,
  filterGroup: FilterGroup,
  addEnableFileFormat: AddEnableFileFormat,
  postSearch: PostSearch,
  globalFieldGroup: GlobalFieldGroup,
  addReportMaster: AddReportMaster,
  addRecordFormat: AddRecordFormat,
  addNightJob: AddNightJob,
  addFieldList: AddFieldList,
  udwLookup: UDWlookup,
  workQueue: WorkQueue,
  logIn: LogIn,
  role: Role,
  refreshToken: RefreshToken,
  notePadTable: NotepadTable,
  columns: Columns,
  addRole: AddRole,
  addUser: AddUser,
  communicationTimeLine: CommunicationTimeLine,
  viewRateTable: ViewRateTable,
  editRateTable: EditRateTable,
  forgotPassword: ForgotPassword,
  nbMaintenance: NbMaintenance,
  systemNotes: SystemNote,
  recordAddNotes: RecordAddNotes,
  addNoteEvent: AddNoteEvent,
  clientData: ClientData,
  unLockUser: UnlockUser,
  dashboardClient: DashboardClient,
  letterBatches: LetterBatches,
  letterHistory: LetterHistory,
  letterGroup: LetterGroup,
  letterControlList: LetterControlList,
  clientRateHistory: ClientRateHistory,
  printusage: printUsage,
  LetterGroupUsage: LetterGroupUsage,
  addPatient: addPatient,
  addTriggerGroup: addTriggerGroup,
  dataManager: DataManager,
  dataManagerFilter: DataManagerFilter,
  dmRecord: DMRecord,
  dMFilterGroup: DMFilterGroup,
  DmRecords: DmRecords,
  dMMatchingLogic: DMMatchingLogic,
  reportMaster: ReportMaster,
  eventTriggerGroup: EventTriggerGroup,
  addFilterRuleGroup: FilterRuleGroup,
  accountUpdateGroup: AccountUpdateGroup,
  dataRepository: DataRepository,
  unsavedChangesAlert: UnsavedChangesAlertReducer,
  dataManagerRecord: DataManagerRecord,
  dataManagerGroup: DataManagerGroup,
  dataManagerRecordGroup: DataManagerRecordGroup,
  letterMaintenance: NewLetterMaintenance,
  lookup: lookupReducer,
  billingIndicator: BillingIndicator,
  myCoverageCare: MyCoverageCare,
  agentInformation: AgentInformation,
  auditFieldList: AuditFieldList,
  intermediateRepo: IntermediateRepository,
  accountBatch: AccountBatch,
  organization: Organization,
  addPrviewFile: AddPrviewFile,
  previewFileData: PreviewFileData,
  translationTableData: TranslationTableData,
  addLookupMaintenance: AddLookupMaintenance,
  newLetterMaintenance: NewLetterMaintenance,
  commonActions: CommonActions,
  ediExport: EdiExport,
  ediFilterExport: EdiFilterExport,
  addWorkQueue: AddWorkQueue,
  workQueueList: WorkQueueList,
  modifiedWindows: ModifiedWindows,
  saveAllWindows: saveAllWindowsSlice,
  eligibleScrub: eligibleScrub,
});
